enum PageExtractionDialogFields {
	TYPE = "type",
	TYPE_SELECTED = "selected",
	TYPE_VARIABLE = "variable",
	TYPE_GROUP = "group",
	TYPE_SEPARATE = "separate",
	DELETE = "delete",
	FROM = "from",
	COUNT = "count",
	PAGERANGE = "pagerange"
}

export default PageExtractionDialogFields;